module.exports = __webpack_public_path__ + "img/user.14849092.svg";